var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('q-header',{staticClass:"bg-primary text-black"},[_c('q-toolbar',{staticStyle:{"height":"80px"}},[_c('q-img',{staticStyle:{"height":"80%"},attrs:{"src":"/statics/WavesLogoWhite.png","contain":""}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }